// This week — team only. What moved in the current weekly window (Wed → Tue),
// counted from the activity rows Home already scopes to it.
//
// No trend line. The 12-week "active pipeline" sparkline this replaces trusted
// the activity log over each deal's actual stage, and drew 106 active deals
// when there were 12 — every deal passed in bulk without a log entry still
// counted as live.
export default function WeekMoves({ moves, weekLabel }) {
  const cells = [
    [moves.toUnderwriting, "moved into underwriting"],
    [moves.toLoi, `LOI${moves.toLoi === 1 ? "" : "s"} submitted`],
    [moves.closedOut, "passed or lost"],
    [moves.total, `stage change${moves.total === 1 ? "" : "s"} in total`],
  ];
  return (
    <section className="rounded-[14px] border border-[#3a3a3a] bg-[#242424] px-6 py-5">
      <h3 className="text-[15px] font-semibold text-[#f4f4f4]">This week</h3>
      <p className="mt-0.5 text-[12px] text-[#8a8a8a]">{weekLabel}</p>
      <div className="mt-4 grid grid-cols-2 gap-y-4 md:grid-cols-4">
        {cells.map(([v, k], i) => (
          <div key={k} className={`px-4 ${i % 4 === 0 ? "md:pl-0" : "md:border-l md:border-[#303030]"}`}>
            <div className="text-[26px] font-light text-[#f4f4f4]">{v}</div>
            <div className="mt-0.5 text-[11px] text-[#8a8a8a]">{k}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
